/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Output of feedback component: businessStudent comment
 */
export interface BusinessStudentCommentOutput {
  text: string;
}
